import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Embed from '../embed/Embed';
import Disclaimer from '../disclaimer/Disclaimer';
import { slugify } from '../../utils';
import classNames from 'classnames';

const Steps = (props) => (
  <ol className="section-tutorial-steps">
    {props.steps.map((step) => (
      <li key={slugify(step.alt)} id={step.id} className="section-tutorial-step">
        <a href={step.link}>
          <LazyLoadImage src={step.img} alt={step.alt} />
        </a>
        <div className="step" dangerouslySetInnerHTML={{ __html: props[step.src] }} />
      </li>
    ))}
  </ol>
);

const Tutorial = (props) => {
  const { title, colourScheme, stepsFirst, disclaimer, embed, customPadding } = props;

  const componentClasses = classNames('tutorial', {
    'tutorial--no-padding-top': customPadding === 'no-top',
    'tutorial--no-padding-bottom': customPadding === 'no-bottom',
    'tutorial--no-padding-top-bottom': customPadding === 'no-padding',
    [`tutorial--${colourScheme}-scheme`]: colourScheme
  });

  return (
    <section className={componentClasses}>
      <div className="tutorial--inner">
        <h2>{title}</h2>
        {stepsFirst ? <Steps {...props} /> : null}

        {embed ? <Embed {...embed} /> : null}
        {!stepsFirst ? <Steps {...props} /> : null}

        {disclaimer ? (
          <div
            className="disclaimer disclaimer--no-padding-top-bottom"
            dangerouslySetInnerHTML={{ __html: props[disclaimer.src] }}
          />
        ) : null}
      </div>
    </section>
  );
};

Tutorial.propTypes = {
  title: PropTypes.string,
  colourScheme: PropTypes.oneOf(['grey', 'dark-navy', 'light-grey', 'transparent']),
  embed: PropTypes.oneOfType([PropTypes.shape(Embed.propTypes), PropTypes.arrayOf(PropTypes.shape(Embed.propTypes))]),
  disclaimer: PropTypes.oneOfType([
    PropTypes.shape(Disclaimer.propTypes),
    PropTypes.arrayOf(PropTypes.shape(Disclaimer.propTypes))
  ]),
  step: PropTypes.string,
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding']),
  stepsFirst: PropTypes.string
};

export default Tutorial;
